import {useState, useRef, useEffect, Children} from "react";
// import {scrollIntoViewWithOffset} from "../utils";
// import {useNavigate} from "react-router-dom";

export const Slide = ({index, children, className, style}) => {
  return (
    <div id={'slide-' + index} className={'slide' + (className ? ' ' + className : '')} style={style}>
      {children}
    </div>
  )
}

export function Slider({view = false, size, children, time, pStyle, onSlide}) {
  const
    // navigate = useNavigate(),
    count = Children.count(children),
    [activeIndex, setActiveIndex] = useState(0),
    slidesRef = useRef(null),
    isRtl = document.documentElement.getAttribute('dir') === 'rtl'
  // hash = window.location.hash.replace('#', '')

  let timer

  useEffect(() => {
    if (time) {
      timer = setInterval(() => {
        setActiveIndex(index => {
          let newIndex

          if (index + 1 < count)
            newIndex = index + 1
          else
            newIndex = 0

          const el = slidesRef.current

          if (isRtl) {
            // Chrome/WebKit (scrollLeft: max → 0)
            if (el.scrollLeft >= 0) {
              el.scrollLeft = el.scrollWidth - el.offsetWidth - newIndex * el.offsetWidth
            }
            // Firefox (scrollLeft: min → 0)
            else {
              el.scrollLeft = -newIndex * el.offsetWidth
            }
          } else {
            el.scrollLeft = newIndex * el.offsetWidth
          }

          return newIndex
        })
      }, time)

      return () => clearInterval(timer)
    }
  }, [time])

  useEffect(() => {
    if (onSlide)
      onSlide(activeIndex)
  }, [activeIndex])

  // useEffect(() => {
  //   // checkHash()
  //
  //   if (!hash)
  //     return
  //
  //   document.getElementById(hash)
  //     // .scrollIntoView({block: 'start', behavior: 'instant'})
  //     .scrollIntoView({block: 'start', behavior: 'smooth'})
  // }, [hash])

  const
    handleScroll = (e) => {
      const {scrollLeft, scrollWidth, offsetWidth} = e.target

      let normalizedScrollLeft = scrollLeft

      if (isRtl) {
        // Chrome/WebKit (scrollLeft: max → 0)
        if (scrollLeft > 0) {
          normalizedScrollLeft = scrollWidth - offsetWidth - scrollLeft
        }
        // Firefox (scrollLeft: min → 0)
        else {
          normalizedScrollLeft = -scrollLeft
        }
      }

      setActiveIndex(Math.round(normalizedScrollLeft / offsetWidth))
    },
    handlePoint = (i, e) => {
      e.preventDefault()

      // navigate(`#${e.target.closest('a').href.split('#')[1]}`)

      // document.getElementById(e.target.closest('a').href.split('#')[1])
      //   .scrollIntoView({block: 'start', behavior: 'smooth'})

      // scrollIntoViewWithOffset(e.target.closest('a').getAttribute('href'), 48)
      // scrollIntoViewWithOffset(e.target.closest('a').getAttribute('href'), 24, 'left')

      // slidesRef.current.scrollTo({
      //   behavior: 'smooth',
      //   left: slidesRef.current.clientWidth * i
      //   // -200
      //   // document.querySelector().getBoundingClientRect().left -
      //   // document.body.getBoundingClientRect().left -
      //   // 24,
      // })

      const el = slidesRef.current
      let left

      if (isRtl) {
        // Chrome/WebKit
        if (el.scrollLeft > 0) {
          left = el.scrollWidth - el.clientWidth - el.clientWidth * i
        }
        // Firefox
        else {
          left = -el.clientWidth * i
        }
      } else {
        left = el.clientWidth * i
      }

      el.scrollTo({
        behavior: 'smooth',
        left
      })
    }

  return (
    <>
      <style>{
`.slider { overflow: hidden; width: 100% }
.slides { display: flex; gap: 12px; align-items: stretch; overflow-x: auto; scroll-snap-type: x mandatory; scroll-behavior: smooth; -webkit-overflow-scrolling: touch; -ms-overflow-style: none; scrollbar-width: none }
.slide { scroll-snap-align: center; flex-shrink: 0; transform-origin: center center; transform: scale(1); transition: transform 0.5s; position: relative; width: 100% }

.view { width: calc(100% + 48px) }
/*.view .slides { padding: 0 24px }*/
/*.view .slides { justify-content: center; padding: 0 24px }*/
.view .slide { width: calc(100% - 48px) }
.view .slide:first-child { width: calc(100% - 24px); padding-left: 24px }
.view .slide:last-child { width: calc(100% - 24px); padding-right: 24px }
/*.view .slide { padding: 0 24px }*/

.slides::-webkit-scrollbar { width: 0; display: none }
.slides::-webkit-scrollbar-thumb { background: transparent; border: 0 }
.slides::-webkit-scrollbar-track { background: transparent }

.slider .points { display: flex; justify-content: center; align-items: flex-start }
.slider .points a { padding: 0.25rem }
.slider .points i { display: block;  width: 0.5rem; height: 0.5rem; border-radius: 50%; background-color: var(--bg-50) }
.slider .points i.active { background-color: var(--white-100) }

.slider.lg .points { gap: 4px }
.slider.lg .points i { width: 12px; height: 12px }`
      }</style>

      <div className={view ? 'view' : 'w-100'}>
        <div className={'slider' + (size ? ` ${size}` : '')}>
          <div ref={slidesRef} className="slides mb-4" onScroll={handleScroll}>
            {children}
          </div>

          <div className={'points'} style={pStyle}>
            {Array.from(Array(count), (e, i) =>
              <a key={i} href={'#slide-' + i} aria-label={'Slide ' + i} onClick={handlePoint.bind(this, i)}>
                <i className={(activeIndex === i ? 'active' : '')}/>
              </a>
            )}
          </div>
        </div>
      </div>
    </>
  )
}